/// <amd-module name="MarkdownEditor/LegacyMentionService" />
import { VssService, IVssPageContext, Services, IVssService } from "VSS/Platform/Context";
import { ILegacyPlatformService } from "VSS/Legacy/Types";

export const LegacyMentionSerivceName = "LegacyMentionSerivce";

export interface IMentionEnhancement {
    dispose: () => void;
}
export interface IMentionNwpWrapper {
    new (
        textArea: HTMLTextAreaElement,
        onSelect: () => void,
        textAreaMirrorContainer: HTMLDivElement,
        textEditorMirror: HTMLSpanElement,
        positioningElement: HTMLDivElement
    ) : IMentionEnhancement;
}

export interface IMentionNwpWrapperModule {
    MentionNwpWrapper: IMentionNwpWrapper;
    translateDisplayNamesToStorageKeysOfPersonMentions: (content: string) => Promise<string>;
    translateStorageKeysToDisplayNamesOfPersonMentions: (content: string) => Promise<string>;
}

export interface ILegacyMentionSerivce extends IVssService {
    enhanceAutocomplete(
        textArea: HTMLTextAreaElement,
        textAreaMirrorContainer: HTMLDivElement,
        textAreaMirror: HTMLSpanElement,
        autoCompletePositionElement: HTMLDivElement,
        onSelect: () => void
    ): Promise<any>;

    translateDisplayNamesToStorageKeysOfPersonMentions: (content: string) => Promise<string>;
    translateStorageKeysToDisplayNamesOfPersonMentions: (content: string) => Promise<string>;
}

export class LegacyMentionSerivce extends VssService implements ILegacyMentionSerivce {
    private _modulesPromise: Promise<any[]>;

    public _serviceStart(pageContext: IVssPageContext) {
        super._serviceStart(pageContext);

        // we could load legacy mention module via contribution
        const legacyPlatformService = pageContext.getService<ILegacyPlatformService>("ILegacyPlatformService");
        this._modulesPromise = legacyPlatformService.requireModules(["Mention/Scripts/MentionNwpWrapper"]);
    }

    public enhanceAutocomplete(
        textArea: HTMLTextAreaElement,
        textAreaMirrorContainer: HTMLDivElement,
        textAreaMirror: HTMLSpanElement,
        autoCompletePositionElement: HTMLDivElement,
        onSelect: () => void
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            this._modulesPromise.then((modules: [IMentionNwpWrapperModule]) => {
                const mentionEnhancement = new modules[0].MentionNwpWrapper(
                    textArea,
                    onSelect,
                    textAreaMirrorContainer,
                    textAreaMirror,
                    autoCompletePositionElement
                );

                resolve(mentionEnhancement);
            });
        });
    }

    public translateDisplayNamesToStorageKeysOfPersonMentions(value: string): Promise<string> {
        return new Promise((resolve, reject) => {
            this._modulesPromise.then((modules: [IMentionNwpWrapperModule]) => {
                const translatedValue = modules[0].translateDisplayNamesToStorageKeysOfPersonMentions(value);
                resolve(translatedValue);
            });
        });
    }

    public translateStorageKeysToDisplayNamesOfPersonMentions(value: string): Promise<string> {
        return new Promise((resolve, reject) => {
            this._modulesPromise.then((modules: [IMentionNwpWrapperModule]) => {
                modules[0].translateStorageKeysToDisplayNamesOfPersonMentions(value).then(result => {
                    resolve(result);
                });
            });
        });
    }
}

Services.add(LegacyMentionSerivceName, { serviceFactory: LegacyMentionSerivce });
